import { render, staticRenderFns } from "./EditResortPage.vue?vue&type=template&id=56e7144c&"
import script from "./EditResortPage.vue?vue&type=script&lang=js&"
export * from "./EditResortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports